import { IClusterCalculatorDefinition } from '~/components/map/types/cluster/IClusterCalculatorDefinition';

const calculator = (gmapMarkers: unknown[]): IClusterCalculatorDefinition => ({
  index: 0,
  text: `<div class="cluster cluster-wrapper"><div class="cluster__count">${gmapMarkers.length}</div></div>`,
});

export default calculator;
